export const filterDataAgendaLila = (dates) => {
    const nowDate = new Date();
    const isDateNow = (dateStr) => {
        const [y, m, d] = dateStr.split('-').map((e) => Number(e));
        return (
            y === nowDate.getFullYear() &&
            m === nowDate.getMonth() + 1 &&
            d === nowDate.getDate()
        );
    };
    const hasMoreThanXHoursDiff = (dateStr, paramHours = 3) => {
        const target = new Date(dateStr.replace(" ", "T"));
        const diffMs = target.getTime() - nowDate.getTime();
        if (diffMs === 0) {
            return false;
        } else if (diffMs > 0) {
            return false;
        } else if (diffMs < 0 && diffMs > (-paramHours * 60 * 60 * 1000)) {
            return false;
        } else {
            return true;
        }
    };

    return dates?.map((element) => {
        if (!isDateNow(element.fecha)) {
            return element;
        }
        return {
            ...element,
            torneos: element.torneos?.map((torneo) => ({
                ...torneo,
                eventos:
                    torneo?.eventos?.filter(
                        (evento) => !hasMoreThanXHoursDiff(evento.startDateUTC)
                    ) ?? [],
            })),
        };
    }) ?? [];
}